import { accountService } from '../services';

const DS_WEBHOOK_SSO = 'https://prod.integratewithfetchgoat.com/fgn-ds-ssologin';
const DS_TOKEN_KEY = 'DSLogin';
const DS_ISSUED_KEY = 'DSLoginIssuedAt';
const DS_TOKEN_TTL_MS = 2 * 60 * 1000; // 24 * 60 * 60 * 1000; // 24 hours

export function getDriverSyncToken(): string | null {
  const token = localStorage.getItem(DS_TOKEN_KEY);
  const issuedAt = localStorage.getItem(DS_ISSUED_KEY);

  if (!token || !issuedAt) {
    console.log('[DriverSync] No stored token found.');
    return null;
  }

  const age = Date.now() - Number(issuedAt);
  if (age >= DS_TOKEN_TTL_MS) {
    console.log(`[DriverSync] Token expired (age: ${(age / 1000 / 60).toFixed(1)} min, TTL: ${(DS_TOKEN_TTL_MS / 1000 / 60).toFixed(0)} min). Clearing.`);
    clearDriverSyncToken();
    return null;
  }

  console.log(`[DriverSync] Token valid (age: ${(age / 1000 / 60).toFixed(1)} min, TTL: ${(DS_TOKEN_TTL_MS / 1000 / 60).toFixed(0)} min).`);
  return token;
}

export function clearDriverSyncToken(): void {
  localStorage.removeItem(DS_TOKEN_KEY);
  localStorage.removeItem(DS_ISSUED_KEY);
}

export async function refreshDriverSyncToken(): Promise<string | null> {
  console.log('[DriverSync] Requesting new handoff token from backend...');
  const res = await accountService.generateDriverSyncToken();
  if (!res.success || !res.result) {
    throw new Error('Failed to generate DriverSync handoff token');
  }

  console.log('[DriverSync] Posting handoff token to SSO webhook...');
  const response = await fetch(DS_WEBHOOK_SSO, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token: res.result }),
  });

  const data = await response.json();
  if (!data?.token) {
    throw new Error('DriverSync SSO webhook did not return a token');
  }

  localStorage.setItem(DS_TOKEN_KEY, data.token);
  localStorage.setItem(DS_ISSUED_KEY, String(Date.now()));
  console.log('[DriverSync] Token refreshed and stored at', new Date().toISOString());
  return data.token as string;
}
